import { useRef, useEffect } from "react";

/**
 * Warn if a component switches between controlled and uncontrolled modes.
 *
 * @param isControlled - whether the component is currently controlled
 * @param componentName - component display name (for clearer warnings)
 * @param propName - prop that determines controlled mode (e.g. "dataState")
 */
export function useControlledSwitchWarning(
    isControlled: boolean,
    componentName: string,
    propName: string
): void {
    const wasControlledRef = useRef(isControlled);

    useEffect(() => {
        if (wasControlledRef.current !== isControlled) {
            console.warn(
                `${componentName}: switched ${
                    wasControlledRef.current ? "from controlled to uncontrolled" : "from uncontrolled to controlled"
                } for prop "${propName}". This is not recommended.`
            );
            wasControlledRef.current = isControlled;
        }
    }, [isControlled, componentName, propName]);
}
